module.exports = __webpack_public_path__ + "components/rewards/isobaa/static/icon-3ef7713fe084eb0fe29cb8da430fc19c.png";